import "./tablegui.css";
import FlowControls from "./flow-controls";
import NodeSelector from "./node-selector";
import NodeInfo from "./node-infos/node-info";
import GraphVisualizer from "./graph-visualizer";
import EstimatesPanel from "./estimates-panel";
import { useStore } from "react-stores";
import { globalStore } from "../globalStore";
import ProgressBar from "./loaders/ProgressBar";
import { Connection } from "@solana/web3.js";

const TableGUI = (props: { connection: Connection }) => {
  const state = useStore(globalStore);
  const selectedAction = state.context.nodes[state.context.selectedNodeId];
  const isSource = selectedAction?.isSource;

  return (
    <div className="table--wrapper">
      <div className="node-info--wrapper">
        <NodeInfo />
        <br />
        {isSource || <EstimatesPanel />}
      </div>
      <div className="flow-controls--wrapper">
        <FlowControls connection={props.connection} />
      </div>
      <div
        id="graph-container"
        // style={{
        //   display: "grid",
        //   gridColumn: 2 / 3,
        //   gap: "1rem",
        //   alignItems: "flex-start",
        // }}
      >
        <div id="canvas-container">
          <GraphVisualizer />
        </div>
        <span className="fine-print">
          Create nodes and edges in the canvas. Delete nodes and edges in the
          editor panel
        </span>

        {state.loading && (
          <div>
            <h4>Running your flow...</h4>
            <ProgressBar
              value={state.loading.progress}
              max={state.loading.max}
              min={0}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TableGUI;
